import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Container, Typography, CircularProgress } from '@mui/material';
import api from '../services/api';
import MovieCard from './MovieCard';
import EmptyState from './EmptyState';

const MoviesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 20px;
  margin-top: 20px;
`;

const WannaWatch = () => {
    const [movies, setMovies] = useState([]);
    const [loading, setLoading] = useState(true);
    const user = JSON.parse(localStorage.getItem('user'));
    const userId = user?.id;

    useEffect(() => {
        const fetchWannaWatch = async () => {
            if (!userId) return;
            setLoading(true);
            try {
                const data = await api.getWannaWatchMovies(userId);
                setMovies(data);
            } catch (err) {
                console.error('Failed to fetch Wanna Watch list:', err);
            } finally {
                setLoading(false);
            }
        };
        fetchWannaWatch();
    }, [userId]);

    const handleRatingUpdate = (movieId, rating) => {
        // If it's rated or dismissed, remove from this list
        setMovies(prev => prev.filter(m => m.id !== movieId));
    };

    if (loading) {
        return (
            <Container sx={{ mt: 4, textAlign: 'center' }}>
                <CircularProgress />
            </Container>
        );
    }

    return (
        <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
            <Typography variant="h4" component="h1" gutterBottom>
                Wanna Watch
            </Typography>
            <Typography variant="body1" color="text.secondary" gutterBottom>
                Movies you've saved to watch later.
            </Typography>

            {movies.length > 0 ? (
                <MoviesGrid>
                    {movies.map(movie => (
                        <MovieCard
                            key={movie.id}
                            movie={movie}
                            userRating={0}
                            onRatingUpdate={handleRatingUpdate}
                        />
                    ))}
                </MoviesGrid>
            ) : (
                <EmptyState
                    message="Your Wanna Watch list is empty."
                    actionText="Browse Popular Movies"
                    onAction={() => window.location.href = '/'}
                />
            )}
        </Container>
    );
};

export default WannaWatch;
